module.exports = __webpack_public_path__ + "static/media/Thank You@2x.2834a65d.png";